export const GRID_STYLE_IMAGE_SIZE_MAP = {
  large: "small",
  small: "tiny",
} as const;
